module.exports = __webpack_public_path__ + "img/logo_original_semFundo.ce3b5b65.svg";